export * from "./RemoveButton";

export interface IRemoveButtonProps {
    AriaLabel: string;
    Disabled?: boolean;
    OnClick: () => void;
}
